import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { contact, primaryCta } from "@/content/site";

// Compact mobile contact pill: appears on scroll-up only, hides near the footer/CTA block and while typing.
export default function MobileBar() {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    let lastY = window.scrollY;
    let blocked = false;
    let typing = false;
    const update = (up) => setShow(up && !blocked && !typing && window.scrollY > 420);

    const onScroll = () => {
      const y = window.scrollY;
      if (Math.abs(y - lastY) < 6) return;
      update(y < lastY);
      lastY = y;
    };
    const targets = document.querySelectorAll('[data-testid="site-footer"], [data-testid="cta-block"], form');
    const visible = new Set();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? visible.add(e.target) : visible.delete(e.target)));
      blocked = visible.size > 0;
      if (blocked) setShow(false);
    }, { rootMargin: "0px 0px 120px 0px" });
    targets.forEach((t) => io.observe(t));
    const onFocusIn = (e) => { if (e.target.matches?.("input, textarea, select")) { typing = true; setShow(false); } };
    const onFocusOut = () => { typing = false; };

    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("focusin", onFocusIn);
    document.addEventListener("focusout", onFocusOut);
    return () => {
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("focusin", onFocusIn);
      document.removeEventListener("focusout", onFocusOut);
      io.disconnect();
    };
  }, [pathname]);

  if (pathname.startsWith("/admin") || pathname === primaryCta.to) return null;
  const iconBtn = "grid h-11 w-11 place-items-center rounded-full border border-ivory/25 text-ivory";

  return (
    <div
      data-testid="mobile-contact-bar"
      aria-hidden={!show}
      className={`fixed bottom-4 right-4 z-40 flex items-center gap-1.5 rounded-full bg-ink/95 p-1 shadow-[0_16px_32px_-16px_rgba(28,27,26,.7)] backdrop-blur md:hidden transition-[transform,opacity] duration-500 ${show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-[160%] opacity-0"}`}
    >
      <Link to={primaryCta.to} tabIndex={show ? 0 : -1} data-track="cta_diagnostic" data-testid="mobile-bar-diagnostic" className="flex h-11 items-center gap-2 rounded-full bg-ivory pl-4 pr-3 text-[14px] font-semibold text-ink">
        Diagnostic <ArrowUpRight className="h-4 w-4" />
      </Link>
      {contact.phone && <a href={`tel:${contact.phoneIntl}`} tabIndex={show ? 0 : -1} aria-label="Appeler le studio" data-track="phone_click" data-testid="mobile-bar-call" className={iconBtn}><Phone className="h-4 w-4" /></a>}
    </div>
  );
}
